module.exports = __webpack_public_path__ + "img/20180815_151844_194.04dbfc06.jpg";